import { API, SERVER } from "./config";

const TOKEN_KEY = "mcs_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

async function req(method, path, body) {
  const headers = {};
  if (body !== undefined) headers["Content-Type"] = "application/json";
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${API}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let msg = `Request failed (${res.status})`;
    try {
      const data = await res.json();
      msg = typeof data.detail === "string" ? data.detail : data.message || msg;
    } catch {}
    throw new Error(msg);
  }
  if (res.status === 204) return null;
  return res.json();
}

export const api = {
  get: (p) => req("GET", p),
  post: (p, b) => req("POST", p, b ?? {}),
  put: (p, b) => req("PUT", p, b ?? {}),
  patch: (p, b) => req("PATCH", p, b ?? {}),
  del: (p) => req("DELETE", p),
};

export const putFileWithProgress = (url, file, onProgress) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", url);
    xhr.setRequestHeader("Content-Type", file.type || "application/octet-stream");
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) onProgress(Math.round((e.loaded / e.total) * 100));
    };
    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`Upload failed (${xhr.status})`)));
    xhr.onerror = () => reject(new Error("Upload failed"));
    xhr.send(file);
  });

const putRaw = (path, file) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", `${SERVER}${path}`);
    xhr.setRequestHeader("Content-Type", file.type || "application/octet-stream");
    const token = getToken();
    if (token) xhr.setRequestHeader("Authorization", `Bearer ${token}`);
    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`Upload failed (${xhr.status})`)));
    xhr.onerror = () => reject(new Error("Upload failed"));
    xhr.send(file);
  });

export const uploadImage = async (file, purpose) => {
  const init = await api.post("/uploads/initiate", {
    filename: file.name,
    contentType: file.type || "image/jpeg",
    size: file.size,
    purpose,
    direct: true,
  });
  const fileId = init.fileId || init.id;
  const rawUrl = init.rawUrl || `/api/uploads/${fileId}/raw`;
  await putRaw(rawUrl, file);
  const done = await api.post(`/uploads/${fileId}/complete`, { parts: [] });
  return done.key;
};
